import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTheme } from "react-jss";
import Select from "../select/Select";
import useStyles from "./TopNavigation.styles";
import { StoreState } from "../../models/states/StoreState";
import Button from "../shared/Button";
import useTranslatable from "../../hooks/useTranslatable";
import { ThemeModel } from "../../models/ThemeModel";
import { changeLanguage } from "../../redux/actions";
import { CULTURE_INFO } from "../../utils/lang";
import { maxBy } from "../../utils/lodash";

interface Props {
    theme: ThemeModel;
}

export default function TopNavigation(props: Props) {
    const { theme: surveyTheme } = props;
    const theme: any = useTheme();
    const classes = useStyles({ theme });
    const {
        LanguageSelectorVisible,
        ViewResponsesButtonVisible,
        LanguageSelectorLabelActive,
    } = theme;

    const dispatch = useDispatch();
    const language = useSelector((state: StoreState) => state.interview.language);
    const languages = useSelector((state: StoreState) => state.interview.questionnaire.languages);

    const longestLanguageNameCode = maxBy(
        languages,
        (code) => CULTURE_INFO[code].nativeName.length,
    );
    const longestLanguageNameLength = CULTURE_INFO[longestLanguageNameCode].nativeName.length;

    const viewResponsesText = useTranslatable(surveyTheme, "PrintResponsesButton");
    const languageSelectorTranslatedText = useTranslatable(surveyTheme, "LanguageSelector");

    function viewResponses() {
        let url = window.location.href;
        let win = null;

        if (url.includes(`/S2`)) {
            url = url.split(`/S2`)[0] + `/S2/Responses/Index?language=${language}`;
            win = window.open(url);
        } else {
            win = window.open(`Responses/Index?language=${language}`);
        }

        if (win) win.focus();
    }
    const languageSelectorLabel = LanguageSelectorLabelActive && (
        <span>{languageSelectorTranslatedText}</span>
    );
    return (
        <aside className={classes.topNavigation} aria-label="Top Navigation">
            {ViewResponsesButtonVisible && (
                <Button
                    className="top-navigation__view-responses"
                    text={viewResponsesText}
                    onClick={viewResponses}
                    size="small"
                />
            )}

            {LanguageSelectorVisible && (
                <>
                    {languageSelectorLabel}
                    <Select
                        id="LANGUAGE_SELECTOR_INPUT"
                        className={classes.languageSelector}
                        value={[language]}
                        size={`${longestLanguageNameLength * 20}px`}
                        onChange={(code) => dispatch(changeLanguage(code[0]))}
                        icon="globe"
                        disabled={languages.length < 2}
                        options={languages.map((code) => ({
                            id: `LANGUAGE_SELECTOR_INPUT_${code.toUpperCase()}`,
                            label: CULTURE_INFO[code.toLowerCase()].nativeName,
                            value: code,
                        }))}
                    />
                </>
            )}
        </aside>
    );
}
